import { IPlanSchema } from '../../../graphql/type/plan';
import PLAN from '../constant/plan';

const plan = {
  isFreePackage: (tempPlan?: IPlanSchema | null) => {
    if (!tempPlan) return true;

    if (
      tempPlan &&
      (!tempPlan.subscription || !tempPlan.subscription.packageData)
    )
      return true;

    const packageData =
      tempPlan && tempPlan.subscription && tempPlan.subscription.packageData
        ? tempPlan.subscription.packageData
        : null;

    if (packageData && packageData.type === PLAN.TYPE.FREE) {
      return true;
    }

    return false;
  },
};
export default plan;
